import {getSiteUrl} from "@/helpers/functions";
import {coerceImageObject, type ImageInput} from "@/helpers/imageObject";

export interface ItemListItem {
    name: string;
    url: string;
    image?: ImageInput;
}

export interface SeoSchemaItemListProps {
    items: ItemListItem[];
    name?: string;
}

const toAbsoluteUrl = (siteUrl: string, url: string): string => {
    if (/^https?:\/\//i.test(url)) return url;
    const path = url.startsWith("/") ? url : `/${url}`;
    return `${siteUrl}${path}`;
};

export function SeoSchemaItemList({items, name}: SeoSchemaItemListProps) {
    if (!items.length) return null;

    const siteUrl = getSiteUrl();
    const schema: Record<string, unknown> = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "itemListElement": items.map((item, idx) => {
            const entry: Record<string, unknown> = {
                "@type": "ListItem",
                "position": idx + 1,
                "name": item.name,
                "url": toAbsoluteUrl(siteUrl, item.url),
            };
            if (item.image) entry.image = coerceImageObject(item.image);
            return entry;
        }),
    };

    if (name) schema.name = name;

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
        />
    );
}
